
import React from 'react';
import Introduction from './Introduction';
import KeyChallenges from './KeyChallenges';
import EssentialTechnologies from './EssentialTechnologies';
import MobileTools from './MobileTools';
import SecurityConsiderations from './SecurityConsiderations';
import Implementation from './Implementation';
import Conclusion from './Conclusion';
import RelatedReading from './RelatedReading';

const RealEstateTech: React.FC = () => {
  return (
    <article className="blog-article space-y-12">
      <Introduction />
      
      <div className="bg-gray-50 p-6 rounded-lg mb-8 border border-gray-200">
        <h3 className="font-semibold text-itmgmt-dark-blue mb-3">Quick Navigation</h3>
        <ul className="space-y-2">
          <li><a href="#key-challenges" className="text-itmgmt-medium-blue hover:text-itmgmt-bright-blue">Key Technology Challenges</a></li>
          <li><a href="#essential-technologies" className="text-itmgmt-medium-blue hover:text-itmgmt-bright-blue">Essential Technology Solutions</a></li>
          <li><a href="#mobile-tools" className="text-itmgmt-medium-blue hover:text-itmgmt-bright-blue">Mobile Technology Solutions</a></li>
          <li><a href="#security-considerations" className="text-itmgmt-medium-blue hover:text-itmgmt-bright-blue">Security Considerations</a></li>
          <li><a href="#implementation" className="text-itmgmt-medium-blue hover:text-itmgmt-bright-blue">Implementation Strategies</a></li>
        </ul>
      </div>
      
      <div id="key-challenges">
        <KeyChallenges />
      </div>
      
      <div id="essential-technologies">
        <EssentialTechnologies />
      </div>
      
      <div id="mobile-tools">
        <MobileTools />
      </div>
      
      <div id="security-considerations">
        <SecurityConsiderations />
      </div>
      
      <div id="implementation">
        <Implementation />
      </div>
      
      <Conclusion />
      
      <RelatedReading />
    </article>
  );
};

export default RealEstateTech;
